import moment from 'moment';
import { isBeforeTodayCheckoutRequestCutoff } from './checkoutRequestCutoff';

export function calculateCheckoutEligibleDates({
  attendanceData,
  checkoutRequests = [],
  unclosedDate = null,
  today = moment()
}) {
  const nowMoment = moment(today);
  const todayStart = nowMoment.clone().startOf('day');

  const blockedDates = new Set(
    (checkoutRequests || [])
      .filter((request) => {
        const status = (request.status || '').toLowerCase();
        return status === 'pending' || status.includes('approved');
      })
      .map((request) => moment(request.requestDate).format('YYYY-MM-DD'))
  );

  const eligible = [];
  const eligibleDateKeys = new Set();

  if (unclosedDate) {
    const unclosedMoment = moment(unclosedDate);

    if (unclosedMoment.isValid()) {
      const unclosedKey = unclosedMoment.format('YYYY-MM-DD');
      
      if (!blockedDates.has(unclosedKey) && !isBeforeTodayCheckoutRequestCutoff(unclosedMoment, nowMoment)) {
        eligible.push(unclosedMoment.startOf('day').toDate());
        eligibleDateKeys.add(unclosedKey);
      }
    }
  }

  if (attendanceData && Array.isArray(attendanceData.dailyHours)) {
    for (let i = 0; i < 30; i += 1) {
      const checkDate = todayStart.clone().subtract(i, 'days');
      const dateKey = checkDate.format('YYYY-MM-DD');

      if (
        blockedDates.has(dateKey) ||
        eligibleDateKeys.has(dateKey) ||
        isBeforeTodayCheckoutRequestCutoff(checkDate, nowMoment)
      ) {
        continue;
      }

      const dayData = attendanceData.dailyHours.find((day) => {
        const dayMoment = moment(day.date);
        return dayMoment.isValid() && dayMoment.isSame(checkDate, 'day');
      });

      const hasAttendanceRecord = Boolean(dayData);
      const hasCheckIn = Boolean(dayData?.firstCheckIn);
      const hasCheckOut = Boolean(dayData?.lastCheckOut);
      const hoursWorked = Number(dayData?.hoursWorked || 0);

      const missingCheckout = hasAttendanceRecord && hasCheckIn && !hasCheckOut;
      const missingAttendance = hasAttendanceRecord && hoursWorked === 0 && !hasCheckOut;

      if ((missingCheckout || missingAttendance) && !checkDate.isAfter(today)) {
        eligible.push(checkDate.toDate());
        eligibleDateKeys.add(dateKey);
      }
    }
  }

  eligible.sort((a, b) => moment(b).valueOf() - moment(a).valueOf());

  return eligible;
}
